import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPageContent } from '../../Apis/content';

export const Aboutuspage = createAsyncThunk('aboutuspages', async (formData, { rejectWithValue }) => {
    try {
        const response = await getPageContent(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const aboutuspageSlice = createSlice({
    name: 'aboutuspage',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearAboutuspageStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Aboutuspage.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Aboutuspage.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Aboutuspage.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearAboutuspageStatus } = aboutuspageSlice.actions;
export default aboutuspageSlice.reducer;

